export default {
    namespaced: true,
    state: {
        data: [],
        main_account: {},
        blocked_account: {},
        deposit_account: {},
        debt_account: {},
        error: false,
        loading: false,
        total: 0,
        perPage: 0,
    },
    mutations: {
        setData: (state, data) => (state.data = data),
        setMainAccount: (state, data) => (state.main_account = data),
        setBlockedAccount: (state, data) => (state.blocked_account = data),
        setDepositAccount: (state, data) => (state.deposit_account = data),
        setDebtAccount: (state, data) => (state.debt_account = data),
        setTotal: (state, total) => (state.total = total),
        setPerPage: (state, perPage) => (state.perPage = perPage),
        setError: (state, error) => (state.error = error),
        removeError: state => (state.error = false),
        loadingProcess: state => (state.loading = true),
        loadingCompleted: state => (state.loading = false),
    },
    actions: {
        fetchLog: ({ commit }, data) => {
            commit("loadingProcess");
            return axios
                .get(`/admin/accounts/${data.id}/excerpt`, {
                    params: {
                        page: data.page,
                        from: data.from,
                        to: data.to,
                    },
                })
                .then(res => {
                    commit("removeError");
                    commit("setData", res.data.data);
                    commit("setMainAccount", res.data.main_account);
                    commit("setBlockedAccount", res.data.blocked_account);
                    commit("setDepositAccount", res.data.deposit_account);
                    commit("setDebtAccount", res.data.debt_account);
                    commit("setTotal", res.data.total);
                    commit("setPerPage", res.data.per_page);
                })
                .catch(err => {
                    commit("setError", err.response.data.message ?? err.message ?? "Неизвестная ошибка");
                    console.error(err);
                })
                .finally(() => commit("loadingCompleted"));
        },
        downloadLogUrl: ({ commit }, data) => {
            return `/api/admin/accounts/${data.id}/excerpt`;
        },
    },
};
